import React from "react";
import { Button } from "@campgladiator/cgui-core.atoms.button";
import { PaginationProps } from "../../";
import styles from "./ellipse-button.module.scss";

type EllipseButtonProps = {
  size: PaginationProps["size"];
};

const EllipseButton = ({ size }: EllipseButtonProps) => (
  <Button
    size={size}
    emphasis="secondary"
    variation="text"
    className={styles.ellipseButton}
    data-size={size}
    disabled
  >
    ...
  </Button>
);

export default EllipseButton;
